import React from "react";
import { Marker, InfoWindow } from "@react-google-maps/api";
import { Fragment, useEffect, useState } from "react";
import { FloatingLabel, Form } from "react-bootstrap";

import high from "../assets/Images/high.png";
import medium from "../assets/Images/medium.png";
import low from "../assets/Images/low.png";
import none from "../assets/Images/none.png";

import highBig from "../assets/Images/highBig.png";
import mediumBig from "../assets/Images/mediumBig.png";
import lowBig from "../assets/Images/lowBig.png";
import noneBig from "../assets/Images/noneBig.png";

import highC from "../assets/Images/highComm.png";
import mediumC from "../assets/Images/mediumComm.png";
import lowC from "../assets/Images/lowComment.png";
import noneC from "../assets/Images/noneComm.png";

import highBigC from "../assets/Images/highBigComm.png";
import mediumBigC from "../assets/Images/mediumBigComm.png";
import lowBigC from "../assets/Images/lowBigComm.png";
import noneBigC from "../assets/Images/noneBigComm.png";

import "../assets/styles/PoleMarker.scss";
import SchoolMarker from "./SchoolMarker";
import { poleType, setCenterType, showInfoTabType } from "../types/customTypes";

const PoleMarker:React.FC<propTypes> = (props: propTypes) => {
    const [hoverModal, setHoverModal] = useState(null);
    const [show, setShow] = useState(null);

    useEffect(() => {
        if (props.resetData) {
            setShow(null);
            setHoverModal(null);
            props.showInfoTab(0);
        }
    }, [props.resetData]); // eslint-disable-line react-hooks/exhaustive-deps

    const showModal = (p) => {
        setShow(p.pole_Id);
        props.showInfoTab(p.pole_Id);
        sessionStorage.setItem("latitude", p.latitude);
        sessionStorage.setItem("longitude", p.longitude);
    };

    const showHoverModal = (p) => {
        setHoverModal(p.pole_Id);
    };

    const showPoleIcon = (p) => {
        if (p.high > 0) {
            return p.comment > 0 ? (hoverModal === p.pole_Id ? highBigC : highC) : (hoverModal === p.pole_Id ? highBig : high);
        }
        if (p.medium > 0) {
            return p.comment > 0 ? (hoverModal === p.pole_Id ? mediumBigC : mediumC) : (hoverModal === p.pole_Id ? mediumBig : medium);
        }
        if (p.low > 0) {
            return p.comment > 0 ? (hoverModal === p.pole_Id ? lowBigC : lowC) : (hoverModal === p.pole_Id ? lowBig : low);
        }
        // Check for comment only
        if (p.comment > 0) {
            return hoverModal === p.pole_Id ? noneBigC : noneC;
        }
        // Default case when all counts are 0
        return hoverModal === p.pole_Id ? noneBig : none;
    };

    function HoverModal(pole) {
        return (
            <div className="card h-100 pole-marker border-0">
                <Fragment key={pole.pole_Number}>
                    <div className="poleinfo mt-1" id="poleinfo">
                        <FloatingLabel controlId="formControlSm" className="mb-2" label="Pole Number" style={{ fontSize: "0.8rem" }}>
                            <Form.Control type="text" defaultValue={pole.pole_Number.replace(/\s+/g, "")} disabled />
                        </FloatingLabel>
                        <FloatingLabel controlId="floatingPoleType" label="Pole Type" className="mb-2" style={{ fontSize: "0.8rem" }}>
                            <Form.Control type="text" defaultValue={pole.pole_Type} disabled />
                        </FloatingLabel>
                        <FloatingLabel controlId="floatingPoleMaterial" label="Pole Material" style={{ fontSize: "0.8rem" }}>
                            <Form.Control type="text" defaultValue={pole.material} disabled />
                        </FloatingLabel>
                    </div>
                    <div className="footer d-flex justify-content-between mx-2" id="footer">
                        <input className="circle border border-dark text-center" id="low" style={{ backgroundColor: "yellow" }} value={pole.low} disabled />
                        <input className="circle border border-dark text-center" id="medium" style={{ backgroundColor: "orange" }} value={pole.medium} disabled />
                        <input className="circle border border-dark text-white bg-danger text-center" id="high" value={pole.high} disabled />
                    </div>
                </Fragment>
          </div>
        );
    }

    return (
        <>
            {props.poles.map((p, index) => (
                <div key={index}>
                    {p.isSchool ?
                        <SchoolMarker school={p} setCenter={props.setCenter} controlImageCreation={props.controlImageCreation} getMapImage={props.getMapImage}/> :
                        <Marker
                            key={index}
                            {...(props.isImagesLoading ? { zIndex: 1000000000 } : {})}
                            onClick={() => showModal(p)}
                            onMouseOver={() => showHoverModal(p)}
                            onMouseOut={() => setHoverModal(null)}
                            position={{ lat: parseFloat(p.latitude), lng: parseFloat(p.longitude) }}
                            icon={showPoleIcon(p)}
                            // defaultVisible={p.visible}
                            visible={p.visible}
                            label={{
                                text: p.pole_Number,
                                fontSize: (hoverModal === p.pole_Id ? "10px" : "8px"),
                                color: p.high > 0 ? "white" : "black",
                            }}
                        >
                            {(!p.isSchool && (hoverModal === p.pole_Id || show === p.pole_Id || props.selectedPoleId === p.pole_Id)) &&
                                <InfoWindow>{HoverModal(p)}</InfoWindow>
                            }
                        </Marker>
                    }
                </div>
            ))}
        </>
    );
}

type propTypes = {
    setCenter: setCenterType,
    showInfoTab: showInfoTabType,
    resetData: boolean,
    poles: poleType[],
    selectedPoleId: string,
    isImagesLoading:boolean,
	controlImageCreation : (a) => void,
    getMapImage: () => void
};

export default PoleMarker;
